function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 69,
  height: 47,
  rx: 5.5,
  fill: "white",
  stroke: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.4688 47L68.9688 35.5V42C68.9688 44.7614 66.7302 47 63.9688 47H29.4688Z",
  fill: "#FD6020"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.4712 19.2217C63.6443 19.2217 64.8395 20.1888 64.8395 22.0155C64.9482 23.4124 63.9703 24.5944 62.6664 24.8093L65.6001 28.7851H63.3183L60.8192 24.9168H60.6019V28.7851H58.7548V19.2217H61.4712ZM60.6019 23.6273H61.1452C62.3404 23.6273 62.8837 23.09 62.8837 22.1229C62.8837 21.2633 62.3404 20.726 61.1452 20.726H60.6019V23.6273ZM52.3441 28.7851H57.5596V27.1733H54.1913V24.5944H57.4509V22.9826H54.1913V20.8335H57.5596V19.2217H52.3441V28.7851ZM46.9113 25.6689L44.4123 19.2217H42.4565L46.4767 29H47.4546L51.4749 19.2217H49.5191L46.9113 25.6689ZM24.8542 24.0571C24.8542 26.7435 27.0274 29 29.7437 29C30.613 29 31.3736 28.7851 32.1342 28.4627V26.3137C31.5909 26.9584 30.8303 27.3882 29.9611 27.3882C28.2226 27.3882 26.81 26.0987 26.81 24.3795V24.1646C26.7014 22.4453 28.1139 20.941 29.8524 20.8335C30.7216 20.8335 31.5909 21.2633 32.1342 21.908V19.759C31.4822 19.3291 30.613 19.2217 29.8524 19.2217C27.0274 19.0068 24.8542 21.2633 24.8542 24.0571ZM21.4859 22.8751C20.3994 22.4453 20.0734 22.2304 20.0734 21.6931C20.182 21.0484 20.7253 20.5111 21.3773 20.6186C21.9205 20.6186 22.4638 20.941 22.8984 21.3708L23.8763 20.0813C23.1158 19.4366 22.1379 19.0068 21.16 19.0068C19.6388 18.8993 18.3349 20.0813 18.2262 21.5857V21.6931C18.2262 22.9826 18.7695 23.7348 20.508 24.272C20.9426 24.3795 21.3773 24.5944 21.8119 24.8093C22.1379 25.0242 22.3552 25.3466 22.3552 25.7764C22.3552 26.5286 21.7032 27.1733 21.0513 27.1733H20.9426C20.0734 27.1733 19.3128 26.636 18.9868 25.8838L17.7916 27.0658C18.4436 28.2478 19.7474 28.8925 21.0513 28.8925C22.7898 29 24.2023 27.7106 24.311 25.9913V25.6689C24.2023 24.3795 23.659 23.7348 21.4859 22.8751ZM15.1839 28.7851H17.031V19.2217H15.1839V28.7851ZM6.6001 19.2217H9.31649H9.85977C12.4675 19.3292 14.532 21.4782 14.4233 24.0571C14.4233 25.454 13.7714 26.7435 12.6848 27.7106C11.7069 28.4627 10.5117 28.8926 9.31649 28.7851H6.6001V19.2217ZM8.99051 27.1733C9.85976 27.2807 10.8377 26.9584 11.4896 26.4211C12.1415 25.7764 12.4675 24.9168 12.4675 23.9497C12.4675 23.09 12.1415 22.2304 11.4896 21.5857C10.8377 21.0484 9.85976 20.7261 8.99051 20.8335H8.44724V27.1733H8.99051Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.6754 19C34.959 19 32.6772 21.1491 32.6772 23.9429C32.6772 26.6292 34.8504 28.8858 37.6754 28.9932C40.5005 29.1007 42.6736 26.8441 42.7822 24.0503C42.6736 21.2565 40.5005 19 37.6754 19V19Z",
  fill: "#FD6020"
});

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 48,
    viewBox: "0 0 70 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.6e5a7b13.svg";
export { ForwardRef as ReactComponent };